import { AnyAction } from "redux";

import { stationsActions } from "../reducer";

import { BestRouteStation } from '../../types';

export const updateBestRouteStations = (bestRouteStations: BestRouteStation[]): AnyAction =>
  stationsActions.setBestRouteStations(bestRouteStations);
